<div
  class="flex flex-col items-start justify-start h-fit w-full pt-9 pb-9 min-[1024px]:pt-32 min-[1024px]:pb-32 min-[1024px]:pl-[38px] min-[1024px]:pr-[38px] bg-cover bg-center"
  [style.backgroundImage]="bgStyle"
>
  <!-- Mobile Container -->
  <div
    class="flex flex-col items-center justify-center h-fit w-full pl-6 pr-6 gap-6 max-w-[1536px] min-[1024px]:pl-0 min-[1024px]:pr-0 min-[1024px]:flex-row min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:max-w-none"
  >
    <!-- Left Column: Heading + Description -->
    <div
      class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:pb-[409px] gap-[31.25px]"
    >
      <!-- Heading -->
      <div
        class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
      >
        <span
          class="text-[#161C23] text-4xl font-bold tracking-[-0.9px] leading-10 text-left w-fit h-fit min-[1024px]:text-5xl min-[1024px]:tracking-[-1.2px] min-[1024px]:leading-[48px] min-[1024px]:w-full"
          >How we Work
        </span>
      </div>
      <!-- Description -->
      <div
        class="flex flex-col items-center justify-center h-fit w-full max-w-[400px] min-[1024px]:items-start min-[1024px]:justify-start"
      >
        <span
          class="text-[#474747] text-base font-normal tracking-normal leading-[26px] text-center w-fit h-fit min-[1024px]:text-lg min-[1024px]:font-bold min-[1024px]:leading-[29.25px] min-[1024px]:w-full min-[1024px]:text-left"
          >We optimize for flow and results. Our rituals are designed by engineers, for engineers,
          eliminating the noise of traditional corporate structures.</span
        >
      </div>
    </div>

    <!-- Cards: Mobile stacked, Desktop 2x2 grid -->
    <!-- Mobile cards -->
    <div
      class="flex flex-col items-start justify-start h-fit w-full max-w-[400px] pt-6 gap-4 min-[1024px]:hidden"
    >
      <app-card
        class="w-full h-fit"
        [title1]="'Flexible'"
        [title2]="'Schedule'"
        [description]="'Our schedule is flexible, focusing on when we perform best, as long as there\'s enough overlap for collaboration.'"
      ></app-card>
      <app-card
        class="w-full h-fit"
        [title1]="'Asynchronous'"
        [title2]="'Standups'"
        [description]="'We start with a daily standup, fully asynchronous, to keep everyone aligned without the meeting fatigue'"
      ></app-card>
      <app-card
        class="w-full h-fit"
        [title1]="'Bi-weekly'"
        [title2]="'Milestones'"
        [description]="'We work in bi-weekly milestones. Gitlab is our single source of truth for code, issues, and documentation.'"
      ></app-card>
      <app-card
        class="w-full h-fit"
        [title1]="'Quality & Code'"
        [title2]="'Reviews'"
        [description]="'Every solution goes through strict code review by senior engineers. UI changes also pass a Design team quality check. Quality is not optional.'"
      ></app-card>
    </div>

    <!-- Desktop cards 2x2 grid -->
    <div class="hidden min-[1024px]:flex flex-col items-start justify-start h-fit w-full gap-4">
      <!-- Row 1 -->
      <div class="flex flex-row items-center justify-start h-fit w-full gap-4">
        <app-card
          class="w-full h-fit"
          [title1]="'Flexible'"
          [title2]="'Schedule'"
          [description]="'Our schedule is flexible, focusing on when we perform best, as long as there\'s enough overlap for collaboration.'"
        ></app-card>
        <app-card
          class="w-full h-fit"
          [title1]="'Asynchronous'"
          [title2]="'Standups'"
          [description]="'We start with a daily standup, fully asynchronous, to keep everyone aligned without the meeting fatigue'"
        ></app-card>
      </div>
      <!-- Row 2 -->
      <div class="flex flex-row items-center justify-start h-fit w-full gap-4">
        <app-card
          class="w-full h-fit"
          [title1]="'Bi-weekly'"
          [title2]="'Milestones'"
          [description]="'We work in bi-weekly milestones. Gitlab is our single source of truth for code, issues, and documentation.'"
        ></app-card>
        <app-card
          class="w-full h-fit"
          [title1]="'Quality & Code'"
          [title2]="'Reviews'"
          [description]="'Every solution goes through strict code review by senior engineers. UI changes also pass a Design team quality check. Quality is not optional.'"
        ></app-card>
      </div>
    </div>
  </div>
</div>
